// extracted by mini-css-extract-plugin
module.exports = {"secureImg":"PaymentPageSecureBlock_secureImg__ttjQx","secureTxt":"PaymentPageSecureBlock_secureTxt__ejXfu"};